import { Table, TableHead, TableRow, TableBody } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  NoDataSkeleton,
  GeneralTableBox,
} from '../../../../../common/components';
import { formatPercentage } from '../../utils/formatters';

const CouponsDetailTable = ({ coupons }) => {
  const hasSimple = (coupons || []).some((c) => Number(c.simple || 0) > 0);
  const hasDouble = (coupons || []).some((c) => Number(c.double || 0) > 0);
  const hasAdequaSimple = (coupons || []).some((c) => Number(c.adequa_simple || 0) > 0);
  const hasAdequaDouble = (coupons || []).some((c) => Number(c.adequa_double || 0) > 0);

  const columns = [
    { key: 'year', label: 'Año' },
    { key: 'month', label: 'Mes' },
    { key: 'fee_number1', label: 'Cuota 1' },
    { key: 'fee_number2', label: 'Cuota 2' },
    hasSimple && { key: 'simple', label: 'Diferimiento simple', align: 'right' },
    hasDouble && { key: 'double', label: 'Diferimiento doble', align: 'right' },
    hasAdequaSimple && {
      key: 'adequa_simple',
      label: 'Diferimiento de adecuación simple',
      align: 'right',
    },
    hasAdequaDouble && {
      key: 'adequa_double',
      label: 'Diferimiento de adecuación doble',
      align: 'right',
    },
    { key: 'total', label: 'Total diferido', align: 'right' },
  ].filter(Boolean);

  const colSpan = columns.length;

  return (
    <GeneralTableBox>
      <Table size="small">
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <HeadTableCell key={column.key} align={column.align}>
                {column.label}
              </HeadTableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {!coupons || coupons.length === 0 ? (
            <NoDataSkeleton colSpan={colSpan} message="Sin cupones diferidos" />
          ) : (
            coupons.map((c, idx) => (
              <TableRow key={`${c.year}-${c.month}-${idx}`}>
                {columns.map((column) => {
                  if (column.key === 'year')
                    return <RowTableCell key="year">{c.year ?? '-'}</RowTableCell>;
                  if (column.key === 'month')
                    return <RowTableCell key="month">{c.month ?? '-'}</RowTableCell>;
                  if (column.key === 'fee_number1') {
                    return (
                      <RowTableCell key="fee1">
                        {c.fee_number1 === 0 ? 'Adecuación' : c.fee_number1 ?? '-'}
                      </RowTableCell>
                    );
                  }
                  if (column.key === 'fee_number2') {
                    return (
                      <RowTableCell key="fee2">
                        {c.fee_number1 === 0
                          ? 'Adecuación'
                          : c.fee_number2 === 0
                          ? '-'
                          : c.fee_number2 ?? '-'}
                      </RowTableCell>
                    );
                  }

                  const value = formatPercentage(c[column.key]);
                  return (
                    <RowTableCell key={column.key} align="right">
                      {value} cuotas
                    </RowTableCell>
                  );
                })}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </GeneralTableBox>
  );
};

export default CouponsDetailTable;
